@if (!env) {
  <div class="ribbon-banner ribbon-right">BETA Version</div>
}
<div class="px-5 min-h-screen flex justify-content-center align-items-center bg-cover bg-center" [style]="{'background-image':'url(assets/statics/bg-login.svg)'}">
  <div class="z-1 text-center">
    <div class="text-900 font-bold text-7xl mb-4">EMSERP</div>
    <p class="line-height-3 mt-0 mb-5 text-700 text-2xl font-medium">Selamat datang, silahkan klik tombol berikut untuk masuk.</p>
    <p-button size="large" styleClass="p-button-raised p-button-primary font-bold" (onClick)="loginSSO()">Masuk dengen EMS SSO</p-button>
  </div>
</div>